export default __webpack_public_path__ + "static/media/event-5.e707bd25.png";